import { differenceInYears } from "date-fns";

export function ageCalculator(dateOfBirth: string): any {
  if (!dateOfBirth || dateOfBirth === '') return 'No DOB Present';
  return differenceInYears(new Date(), new Date(dateOfBirth)) || 'UNKNOWN';
};
